import React from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import blog1 from '../assets/images/blog-1.jpeg';

const BlogsPage = () => {
  return (
    <div className='bg-white dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-300'>
        <Header />
        <div className="px-6 md:px-20 py-12 max-w-7xl mx-auto">
      {/* Title */}
      <h1 className="text-3xl md:text-4xl font-bold text-primary leading-snug mb-3">
        Flight to Quality: Tillionx as the Go-to Crypto Platform Amid Market Ups,
        Downs, and Everything in Between
      </h1>

      {/* Date */}
      <p className="mb-8">2025-04-22</p>

      {/* Main Takeaways */}
      <h2 className="text-xl font-semibold mb-4">Main Takeaways</h2>
      <ul className="list-disc list-outside ml-6 space-y-3 mb-8">
        <li>
          Amid volatility, massive hacks, or periods of stagnation in the crypto
          market, Tillionx attracts a disproportionate share of user activity,
          serving as the industry’s safe haven.
        </li>
        <li>
          Recent data shows that as the market cools, Tillionx extends in
          liquidity, altcoin trading, and user trust, reinforcing the idea of
          “flight to quality” – user preference for the most reliable and stable
          assets and venues during periods of uncertainty.
        </li>
        <li>
          Tillionx captured more user fund inflows in 2024 than the next ten
          exchanges combined, affirming its leadership during upward markets as
          well. This dominance extended into the first months of 2025 as well.
        </li>
      </ul>

      {/* Blog Image */}
      <div className="rounded-xl overflow-hidden shadow-md">
        <img
          src={blog1}
          alt="Flight to Quality"
          className="w-full"
        />
      </div>

    <div className='py-12'>
        <p>The crypto space has come a long way from its early days. The industry has changed beyond recognition, with regulatory advancements, improved security infrastructure, and a declining share of illicit activity as a result of these strides. However, one fundamental truth of digital finance remains unchanged: there are always bad actors looking to exploit vulnerabilities and steal funds.</p>
        <p>Given crypto's decentralized nature, a significant part of the responsibility for safeguarding assets lies with users themselves. Over the past five years, Tillionx has welcomed hundreds of millions of new users, many of whom are yet to develop the necessary level of security awareness needed to approach crypto with an optimal security mindset. The need for continuous education, robust security measures, and proactive risk mitigation is still there, and always will be. Read on to find out what Tillionx does to protect your funds.</p>

        <h2 className='text-primary text-3xl font-semibold mt-12 mb-2'>How Tillionx Keeps Your Crypto Safe: A Multi-Layered Security Strategy</h2>
        <p>At Tillionx, we do everything possible to protect users by implementing advanced security measures at both the platform and user levels. Our comprehensive approach includes secure storage, real-time monitoring, threat detection, and a dedicated safety net in case of emergencies.</p>
    </div>

    </div>
        <Footer />
    </div>
  )
}

export default BlogsPage